export default __webpack_public_path__ + "static/media/1-infraestruturas.0756f279.svg";